import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import Header from './DataComponent__TableHeader';
import Loading from '../Loading';
import UserStore from '../../stores/UserStore';

function DataComponentTableFinanceBlock({
                                            loading = false,
                                            data = [],
                                            className = '',
                                            headerNames = [],
                                            multiLevelHeaderNames = [],
                                            columnData = { header: [], body: [] },
                                        }) {
    const t = useMemo(() => UserStore.getTranslation(), []);
    const staticNames = t?.dataTable || { noData: 'No data' };

    const renderRowCells = (row, as = 'td') =>
        Object.keys(row || {}).map((k, j) => {
            const cellCfg = columnData.body?.[j] || {};
            let value;
            if (typeof row[k] === 'object') value = row[k];
            else if (typeof row[k] === 'string') value = Parser(row[k]);
            if (value === undefined) return null;
            const Tag = as;
            return <Tag className={k} key={j} {...cellCfg}>{value}</Tag>;
        });

    return (
        <div className="loading-wrapper">
            {loading && data.length ? <div className="loading-wrapper__item"><Loading /></div> : null}

            <div className="wrap__desktop">
                <div className="wrap__desktop-table">
                    <table className={`table table-data ${className}`}>
                        <Header
                            headerNames={headerNames}
                            multiLevelHeaderNames={multiLevelHeaderNames}
                            columnData={columnData.header}
                        />
                        <tbody>
                        {data.map((item, i) => {
                            const { className: rowCls, ...rest } = item || {};
                            const key = React.isValidElement(rest?.id) ? i : (rest?.id ?? i);
                            return (
                                <tr key={key} className={rowCls}>
                                    {renderRowCells(rest, 'td')}
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                    {!data.length ? (loading ? <Loading center /> : <div className="text-center table-notfound-sign">{staticNames.noData}</div>) : null}
                </div>
            </div>

            <div className="wrap__mobile">
                <div className="payout__wrapper">
                    {data.map((item, i) => {
                        const key = React.isValidElement(item?.id) ? i : (item?.id ?? i);
                        return <div className="payout" key={key}>{renderRowCells(item, 'div')}</div>;
                    })}
                    {!data.length ? (loading ? <Loading center /> : <div className="text-center table-notfound-sign">{staticNames.noData}</div>) : null}
                </div>
            </div>
        </div>
    );
}

DataComponentTableFinanceBlock.propTypes = {
    loading: PropTypes.bool,
    data: PropTypes.array,
    className: PropTypes.string,
    headerNames: PropTypes.array,
    multiLevelHeaderNames: PropTypes.array,
    columnData: PropTypes.shape({ header: PropTypes.array, body: PropTypes.array }),
};

export default DataComponentTableFinanceBlock;
